<template>
  <div>
    <div
      class="lm-qms-number-input form-group"
      :class="[
        alignClass
      ]"
    >
      <h3>{{label}}</h3>
      <div class="btn-group-vertical" role="group">
        <div class="btn-group">
          <input
            :autofocus="autofocus"
            @input="$emit('input', $event.target.value !== '' ? Number($event.target.value) : '')"
            :value="value"
            @focusout="validateOnfocusOutMethod"
            class="form-control-lg text-center mb-2"
            :class="{'is-invalid': v.$error}"
            onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
            type="number"
            :id="idComputed"
            :disabled="disabled"
          />
        </div>
        <div class="btn-group">
            <button type="button" :style="numericButtonStyles" class="btn btn-outline-secondary py-3" @click="onClick(1)">1</button>
            <button type="button" :style="numericButtonStyles" class="btn btn-outline-secondary py-3" @click="onClick(2)">2</button>
            <button type="button" :style="numericButtonStyles" class="btn btn-outline-secondary py-3" @click="onClick(3)">3</button>
        </div>
        <div class="btn-group">
            <button type="button" :style="numericButtonStyles" class="btn btn-outline-secondary py-3" @click="onClick(4)">4</button>
            <button type="button" :style="numericButtonStyles" class="btn btn-outline-secondary py-3" @click="onClick(5)">5</button>
            <button type="button" :style="numericButtonStyles" class="btn btn-outline-secondary py-3" @click="onClick(6)">6</button>
        </div>
        <div class="btn-group">
            <button type="button" :style="numericButtonStyles" class="btn btn-outline-secondary py-3" @click="onClick(7)">7</button>
            <button type="button" :style="numericButtonStyles" class="btn btn-outline-secondary py-3" @click="onClick(8)">8</button>
            <button type="button" :style="numericButtonStyles" class="btn btn-outline-secondary py-3" @click="onClick(9)">9</button>
        </div>
        <div class="btn-group">
            <button type="button" :style="deleteButtonStyles" class="btn btn-outline-secondary py-3" @click="onDelete">X</button>
            <button type="button" :style="numericButtonStyles" class="btn btn-outline-secondary py-3" @click="onClick(0)">0</button>
            <button type="button" :style="backspaceButtonStyles" class="btn btn-outline-secondary py-3" @click="onBackspace">&lt;</button>
        </div>

      </div>
    </div>
    <div class="row" :align="okButton.componentProps.buttonAlign">
      <LmQmsButton
        id="ok-button"
        :disabled="!isValid"
        :class="okButton.class"
        v-bind="okButton.componentProps"
      />
    </div>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
import LmQmsButton from '@/components/form/elements/LmQmsButton'

export default {
  mixins: [lmInputMixin],
  components: {
    LmQmsButton
  },
  props: {
    validations: {
      type: Object
    },
    buttonBgColor: {
      type: String,
      default: '#fff'
    },
    buttonColor: {
      type: String,
      default: '#000'
    },
    deleteButtonBgColor: {
      type: String,
      default: '#4a86e8'
    },
    deleteButtonColor: {
      type: String,
      default: '#fff'
    },
    backspaceButtonBgColor: {
      type: String,
      default: '#4a86e8'
    },
    backspaceButtonColor: {
      type: String,
      default: '#fff'
    },
    okButton: {
      type: Object
    }
  },
  computed: {
    alignClass () {
      if (this.align === 'center') {
        return 'justify-content-center'
      } else if (this.align === 'left') {
        return 'justify-content-left'
      } else if (this.align === 'right') {
        return 'justify-content-end'
      } else {
        return 'justify-content-center'
      }
    },
    numericButtonStyles () {
      return {
        width: this.buttonWidth,
        height: this.buttonHeight,
        background: this.buttonBgColor,
        color: this.buttonColor }
    },
    deleteButtonStyles () {
      return {
        width: this.buttonWidth,
        height: this.buttonHeight,
        background: this.deleteButtonBgColor,
        color: this.deleteButtonColor }
    },
    backspaceButtonStyles () {
      return {
        width: this.buttonWidth,
        height: this.buttonHeight,
        background: this.backspaceButtonBgColor,
        color: this.backspaceButtonColor }
    },
    isValid () {
      let currentValLength = this.value.toString()?.length || 0
      return (currentValLength >= this.validations.minLength && currentValLength <= this.validations.maxLength)
    }
  },
  methods: {
    onClick (val) {
      let currentVal = this.value.toString()
      if (currentVal.length < this.validations.maxLength) {
        this.$emit('input', Number(currentVal + val))
      }
    },
    onDelete () {
      this.$emit('input', '')
    },
    onBackspace () {
      let currentVal = this.value.toString()
      if (currentVal.length > 1) {
        this.$emit('input', Number(currentVal.slice(0, -1)))
      } else {
        this.$emit('input', '')
      }
    }
  }

}
</script>
